<template>
    <PanelPage>
        <template v-slot:title>
            <SmartBreadcrumbs
                type="InertiaLink"
                :pages="[
                    {
                        name: $tc('messages.sociogram_surveys', 2),
                        href: meta.links.index,
                    },
                    {
                        name: $t('messages.create'),
                        href: null,
                    },
                ]"
            />
        </template>

        <div class="text-gray-700">
            {{ $t('messages.sociogram_survey_form_step_0') }}
        </div>

        <form :action="meta.links.update" method="post" @submit.prevent="submit" class="mt-3">
            <TitleFieldsFormSection>
                <template v-slot:title>
                    <span class="text-gray-700">1. {{ $t('messages.sociogram_survey_form_step_group') }}</span>
                </template>
                <div class="md:grid md:grid-cols-12 md:gap-6">
                    <div class="sm:col-span-6">
                        <div class="mt-1">
                            <FormLabel :value="$tc('messages.groups', 1)" for="group_id" />
                            <FormSelect
                                required
                                id="group_id"
                                v-model="form.group_id"
                                :options="options.groups"
                                class="mt-1"
                            />
                            <FormError :value="form.errors.group_id" class="mt-2" />
                        </div>
                    </div>
                </div>
            </TitleFieldsFormSection>
            <TitleFieldsFormSection>
                <template v-slot:title>
                    <span class="text-gray-700">2. {{ $t('messages.sociogram_survey_form_step_sociogram') }}</span>
                </template>
                <div class="md:grid md:grid-cols-12 md:gap-6">
                    <div class="sm:col-span-12">
                        <div class="mt-1">
                            <FormLabel :value="$tc('messages.sociograms', 1)" for="sociogram_id" />
                            <SociogramFormRadioGroupCards
                                required
                                id="sociogram_id"
                                v-model="form.sociogram_id"
                                :options="options.sociograms"
                                class="mt-1"
                            />
                            <FormError :value="form.errors.sociogram_id" class="mt-2" />
                        </div>
                    </div>
                </div>
            </TitleFieldsFormSection>

            <TitleFieldsFormSection>
                <template v-slot:title>
                    <span class="text-gray-700">3. {{ $t('messages.sociogram_survey_form_step_dates') }}</span>
                </template>
                <div class="md:grid md:grid-cols-12 md:gap-6">
                    <div class="sm:col-span-6">
                        <div class="mt-1">
                            <FormLabel :value="$t('messages.published_at')" for="opened_at" />
                            <FormInput
                                id="opened_at"
                                required
                                v-model="form.opened_at"
                                name="opened_at"
                                type="datetime-local"
                                class="mt-1"
                            />
                            <FormError :value="form.errors.opened_at" class="mt-2" />
                        </div>
                    </div>

                    <div class="sm:col-span-6">
                        <div class="mt-1">
                            <FormLabel :value="$t('messages.unpublished_at')" for="closed_at" />
                            <FormInput
                                id="closed_at"
                                required
                                v-model="form.closed_at"
                                name="closed_at"
                                type="datetime-local"
                                class="mt-1"
                            />
                            <FormError :value="form.errors.closed_at" class="mt-2" />
                        </div>
                    </div>
                </div>
            </TitleFieldsFormSection>

            <div class="flex justify-end mt-5">
                <SubmitFormButton :button-text="$t('messages.save')" :processing="form.processing" />
            </div>
        </form>

        <AppWell class="mt-5">
            <div class="p-2 text-gray-600 text-sm">
                {{ $t('messages.sociogram_student_answers_explanation') }}
            </div>
        </AppWell>
    </PanelPage>
</template>

<script>
import Layout from '@/Shared/Layout.vue';
import PanelPage from '@/Shared/PanelPage.vue';
import TitleFieldsFormSection from '@/components/TitleFieldsFormSection.vue';
import FormInput from '@/components/Forms/FormInput.vue';
import FormLabel from '@/components/Forms/FormLabel.vue';
import FormError from '@/components/Forms/FormError.vue';
import FormSelect from '@/components/Forms/FormSelect.vue';
import SubmitFormButton from '@/Pages/Teacher/Activities/Subactivities/SubmitFormButton.vue';
import SociogramFormRadioGroupCards from './partials/SociogramFormRadioGroupCards.vue';
import AppWell from '@/Shared/AppWell.vue';

export default {
    components: {
        AppWell,
        SociogramFormRadioGroupCards,
        SubmitFormButton,
        PanelPage,
        TitleFieldsFormSection,
        FormInput,
        FormLabel,
        FormError,
        FormSelect,
    },
    layout: Layout,
    name: 'Create',
    props: ['meta', 'options'],
    data() {
        return {
            form: this.$inertia.form({
                sociogram_id: null,
                group_id: '',
                opened_at: '',
                closed_at: '',
            }),
        };
    },
    methods: {
        submit() {
            this.form.post(this.meta.links.store);
        },
    },
};
</script>
